// Cores e estilos comuns da tela Férias e Licenças (redesenho 27/10/2026).

export const AZUL_ABA = '#1976d2';

export function coresTipo(tipo: string): { bg: string; cor: string } {
  if (tipo === 'FERIAS_PLANEJADAS' || tipo === 'FERIAS_GOZADAS') return { bg: '#ede9fe', cor: '#4c1d95' };
  if (tipo === 'LICENCA_PREMIO') return { bg: '#fef3c7', cor: '#78350f' };
  return { bg: '#F3F4F6', cor: '#374151' };
}

export const ALERTA = { bg: '#fee2e2', cor: '#991b1b' };
export const LARANJA = { bg: '#ffedd5', cor: '#9a3412' };
export const AZUL_CLARO = { bg: '#e3f2fd', cor: '#0d47a1' };
export const VERDE_ESCURO = '#065F46';

/** Calendário: verde = completa, amarelo = 1 a 3 fora, vermelho = 4 ou mais. */
export function coresDia(fora: number): { bg: string; borda: string; texto: string } {
  if (fora === 0) return { bg: '#dcfce7', borda: '#16a34a', texto: '#14532d' };
  if (fora <= 3) return { bg: '#fef3c7', borda: '#d97706', texto: '#78350f' };
  return { bg: '#fee2e2', borda: '#dc2626', texto: '#7f1d1d' };
}

export const CINZA_DIA = { bg: '#F3F4F6', borda: '#E5E7EB', texto: '#9CA3AF' };

export const CARTAO_SX = {
  borderRadius: 3,
  border: '1px solid #E5E7EB',
  backgroundColor: 'white',
};
